import Swiper from 'swiper';


// Swiper set IDs
export function setIdForAllSwipers() {
    var swiperContainers = document.querySelectorAll('.swiper');
    if (swiperContainers) {
        let swiperRandomID = Math.random().toString(36).substring(7);
        swiperContainers.forEach(function (swiperContainer) {
            swiperContainer.parentElement.setAttribute('data-swiperid', swiperRandomID);
        });
    }
}

// init swiper under px threshold
export function initiateSwiperOnThreshold(swiperContainer, threshold, windowWidth, swiperArgs) {
    const existingSwiper = swiperContainer.swiper;

    if (windowWidth >= threshold) {
        if (existingSwiper) {
            existingSwiper.destroy();
        }
    } else if (!existingSwiper) {
        new Swiper(swiperContainer, swiperArgs);
    }
}

export function initiateSwiperOnThresholdInverted(swiperContainer, threshold, windowWidth, swiperArgs) {
    const existingSwiper = swiperContainer.swiper;

    if (windowWidth <= threshold) {
        if (existingSwiper) {
            existingSwiper.destroy();
        }
    } else if (!existingSwiper) {
        new Swiper(swiperContainer, swiperArgs);
    }
}